import { render, staticRenderFns } from "./safe_strategy.vue?vue&type=template&id=6f30abf4&scoped=true"
import script from "./safe_strategy.vue?vue&type=script&lang=js"
export * from "./safe_strategy.vue?vue&type=script&lang=js"
import style0 from "./safe_strategy.vue?vue&type=style&index=0&id=6f30abf4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f30abf4",
  null
  
)

export default component.exports